/* eslint-disable camelcase */
import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { resetError } from "../../actions/errors";
import PinModal from "../../components/pin";
import { fetchCountries } from "../../actions/countries";
import { createDstExtraRule } from "../../actions/dst-extra-rules";
import { MONTH_NAMES } from "../../constants/month-names";

class DstExtraRuleNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.requestSubmit = this.requestSubmit.bind(this);
    this.failedSubmit = this.failedSubmit.bind(this);
  }

  componentWillMount() {
    const { getCountries } = this.props;
    getCountries();
  }

  handleChange(e, name) {
    const { value } = e.target;
    this.setState({ [name]: value });
  }

  requestSubmit(e) {
    e.preventDefault();
    this.setState({
      submitted: true,
    });
  }

  failedSubmit() {
    this.setState({
      submitted: false,
    });
  }

  handleSubmit() {
    const { createDstExtraRuleAction, goToList, resetErrorAction } = this.props;
    resetErrorAction();
    const {
      start_month,
      start_day,
      end_month,
      end_day,
      year,
      country_id,
    } = this.state;
    const body = {
      start_month,
      start_day,
      end_month,
      end_day,
      year,
      country_id,
    };
    Object.keys(body).forEach(
      (key) => body[key] === undefined && delete body[key],
    );
    createDstExtraRuleAction({ body: JSON.stringify(body) }).then(() => {
      goToList();
    });
  }

  render() {
    const {
      start_month,
      start_day,
      end_month,
      end_day,
      year,
      submitted,
    } = this.state;
    const { goToList, countries } = this.props;
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal
            successSubmit={this.handleSubmit}
            failedSubmit={this.failedSubmit}
          />
        )}
        <Row>
          <Col lg={6}>
            <Card>
              <Form onSubmit={(e) => this.requestSubmit(e)}>
                <CardHeader>
                  <strong>{"New DST Extra Rule"}</strong>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label htmlFor="start_month">DST Start Month</Label>
                    <Input
                      type="select"
                      name="start_month"
                      id="start_month"
                      invalid={submitted && !MONTH_NAMES[start_month]}
                      onChange={(e) => this.handleChange(e, "start_month")}
                      required
                    >
                      <option value={""}>Select an option...</option>
                      {MONTH_NAMES.map((month, index) => (
                        <option key={month} value={index}>
                          {month}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="start_day">DST Start Day</Label>
                    <Input
                      id="start_day"
                      type="text"
                      placeholder="Enter DST Start Day"
                      invalid={submitted && start_day === ""}
                      onChange={(e) => this.handleChange(e, "start_day")}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_month">DST End Month</Label>
                    <Input
                      type="select"
                      name="end_month"
                      id="end_month"
                      invalid={submitted && !MONTH_NAMES[end_month]}
                      onChange={(e) => this.handleChange(e, "end_month")}
                      required
                    >
                      <option value={""}>Select an option...</option>
                      {MONTH_NAMES.map((month, index) => (
                        <option key={month} value={index}>
                          {month}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_day">DST End Day</Label>
                    <Input
                      id="end_day"
                      type="text"
                      placeholder="Enter DST End Day"
                      invalid={submitted && end_day === ""}
                      onChange={(e) => this.handleChange(e, "end_day")}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="year">Year</Label>
                    <Input
                      id="year"
                      type="text"
                      placeholder="Enter Year"
                      invalid={submitted && year === ""}
                      onChange={(e) => this.handleChange(e, "year")}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="country_id">Country</Label>
                    <Input
                      type="select"
                      name="country_id"
                      id="country_id"
                      onChange={(e) => this.handleChange(e, "country_id")}
                      required
                    >
                      <option value={""}>Select an option...</option>
                      {countries.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button type="submit" size="sm" color="primary">
                    Create
                  </Button>{" "}
                  <Button onClick={() => goToList()} size="sm" color="danger">
                    Cancel
                  </Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

DstExtraRuleNew.propTypes = {
  getCountries: PropTypes.func.isRequired,
  createDstExtraRuleAction: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
  resetErrorAction: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.object),
};
DstExtraRuleNew.defaultProps = {
  countries: [],
};

const mapStateToProps = ({ countries }) => ({
  countries: [...countries.items].sort((a, b) => {
    return a.name.localeCompare(b.name);
  }),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCountries: () => fetchCountries(),
      createDstExtraRuleAction: (body) => createDstExtraRule(body),
      goToList: () => push("/dst-extra-rules"),
      resetErrorAction: () => resetError(),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DstExtraRuleNew);
